import $ from 'jquery'

// Long enough to survive a normal mid-thought typing pause without waiting for Enter; still
// short enough to feel like search-as-you-type.
const DEBOUNCE_MS = 1200

// Form with autocomplete field.
document
  .querySelectorAll('input[data-behavior~="autocomplete-form-field"]')
  .forEach((field) => {
    let timeoutId

    // Get the search term
    const search = () => {
      if (field.value !== '') {
        // Need to do this with jQuery, with bare JS submit() it doesn't do the remove behaviour for whatever reason.
        $(field.closest('form')).submit()
      }
    }

    field.addEventListener('input', (e) => {
      clearTimeout(timeoutId)
      // debounce timeout
      timeoutId = setTimeout(search, DEBOUNCE_MS)
    })

    // Cancel a pending auto-search if the user leaves the field before it fires -- a longer
    // debounce window makes a stale search more likely to land after they've already moved on
    // (clicked elsewhere, tabbed away, closed a search modal).
    field.addEventListener('blur', () => {
      clearTimeout(timeoutId)
    })
  })
